import { handleRequest } from "../utils/axios";

export const synthesizeTextToSpeech = async (text, gender) => {
  const config = {
    url: `/texttospeech/synthesize`,
    method: 'POST',
    data: { text, gender },
    responseType: 'arraybuffer',
  };

  const resp = await handleRequest(config);

  if (resp instanceof ArrayBuffer) {
    const audioBlob = new Blob([resp], { type: 'audio/mp3' });
    return URL.createObjectURL(audioBlob);
  }
  return null;
};